module.exports = new __parcel__URL__("bossfight_star_dust_button_inactive.c1502f95.png").toString();